export default __webpack_public_path__ + "static/media/Arm_left.5edc4179.svg";